<template>
    <Transition name="staffSearch">
      <div v-modal-focus v-if="isModalStaffSearchVisible" :id="StaffSearchId" class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 500px;
            "
          >
            <h6>スタッフ検索</h6>
            <input
              class="form-control"
              v-model="StaffName"
              style="width: 150px"
            />
            <button class="btn btn-dark m-3" @click="cancelAction">
              閉じる
            </button>
          </div>
        </div>

        <!-- ページネーションを下に移動 -->
        <div
          class="pagination"
          style="
            display: flex;
            align-items: center;
            justify-content: center; /* 中央揃え */
            margin-top: 10px; /* 上に余白を追加 */
            width: 100%;
          "
        >
          <vue-awesome-paginate
            :total-items="
              Staffs.filter((Staff) =>
              Staff.staffName?.includes(StaffName)
              ).length
            "
            :items-per-page="itemsPerPage"
            :max-pages-shown="2"
            v-model="currentPage"
            @click="clickCallback"
          />
        </div>
  
          <div class="modal-body">
            <table class="table table-hover table-bordered table-striped w-auto table-sm">
              <thead>
                <tr>
                  <th>コード</th>
                  <th>スタッフ名</th>
                  <th>選択</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="Staff in paginatedList" :key="Staff.staffCode">
                  <td>
                    <input
                      class="form-control"
                      v-model="Staff.staffCode"
                      disabled
                      style="width: 120px"
                    />
                  </td>
                  <td>
                    <input
                      class="form-control"
                      v-model="Staff.staffName"
                      style="width: 250px"
                      disabled
                    />
                  </td>
                    <td>
                    <button
                      class="btn btn-primary"
                      style="width: 80px"
                      @click="selectedAction(Staff)"
                    >
                      選択
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <div class="modal-footer" style="height: 0px">
            <!-- <slot name="footer">
   
             </slot> -->
          </div>
        </div>
      </div>
    </Transition>
  </template>
  
  <script setup lang="ts">
  import { ref, onMounted, computed, inject, toRefs,watch } from "vue";
  import type { Ref } from "vue";
  import axios from "axios";
  import { TblMStaff } from "../models/TblMStaff";
  import type { ITblMStaffData } from "../models/TblMStaff";
  import CompanyService from "../Js/CompanyService";
  // import FlatPicker from "../components/MyFlatPicker.vue";
  // import "flatpickr/dist/flatpickr.css";
  import type { ToastPluginApi } from "vue-toast-notification";
  import MyCommon from "../Js/MyCommon";
  import VueDatePicker from "@vuepic/vue-datepicker";
  import "@vuepic/vue-datepicker/dist/main.css";
  
  const myCommon = ref(new MyCommon());
  const StaffName: Ref<string> = ref("");
  const toast: ToastPluginApi | undefined = inject("toast");
  
  const Staffs: Ref<TblMStaff[]> = ref([new TblMStaff()]);
  const currentPage = ref(1);
  const itemsPerPage = ref(10);
  const lastPage = computed(() =>
       Math.ceil(Staffs.value.
        filter(Staff => Staff.staffName?.includes(StaffName.value)).length / itemsPerPage.value)
  );
  const companyService = CompanyService; //既にexport default new CompanyService();をしている。
  
  const clickCallback = (pageNum: number) => {
    currentPage.value = pageNum;
  };
  
  const clearItem = async () => {
    clickCallback(1);
    await init();
  };
  
  const init = async () => {
    //axios.defaults.headers.common['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`; //Tokenの場合
    axios.defaults.withCredentials = true; //Cookieの場合
    await getList();
  };
  // APIからユーザーリストを取得する
  async function getList() {
    try {
      const response = await axios.get(`${import.meta.env.VITE_API_TARGET}/api/mStaff/GetLists`);
      if (response.status === 200) {
        const StaffList: Ref<TblMStaff[]> = ref([new TblMStaff()]);
          StaffList.value = response.data.map((item: ITblMStaffData) => {
          // birthdayを日本時間に変換
          // 新しいユーザーオブジェクトを作成し、変換された日付を使用
          return new TblMStaff({ ...item });
        }) .sort((a: ITblMStaffData, b: ITblMStaffData) => {
        // StaffCodeを数値に変換して比較
        return Number(a.staffCode) - Number(b.staffCode);
      });

        Staffs.value = StaffList.value;
      }
    } catch (error: any) {
      // サーバーからのエラーメッセージを取得
      if (error.response) {
        const errorMessage =
          error.response.data ?? "エラーが発生し処理を中止しました。";
        console.error("API Error:", errorMessage);
        toast?.error(errorMessage);
        throw new Error(errorMessage); // エラーをスローして呼び出し元に渡す
      } else {
        console.error("Unexpected Error:", error);
        toast?.error("通信エラーが発生しました。");
        throw new Error("通信エラーが発生しました。");
      }
    }
  }
  
  // Props と Emits
  //「コンポーネント間のデータのやり取り」では
  //「親から子」にdataを伝達する手段「props」
  //「子から親」にdataを伝達する手段「emit」が存在します。
  
  //親から子」にdataを伝達する手段「props」親から設定する。
const props = defineProps({
  StaffSearchId: String,
  isModalStaffSearchVisible: Boolean,
  selectedActionStaffSearchCallback: Function,
});
      
  const emit = defineEmits(["cancel-action", "close-modal", "selected-action"]);
  
  //const { isModalVisible } = toRefs(props);
  
  const closeModal = () => {
    emit("close-modal");
  };
  
  const cancelAction = () => {
    emit("cancel-action");
    closeModal();
  };
  
  // ユーザー選択時の処理
  const selectedAction = (Staff: TblMStaff) => {
    emit("selected-action", Staff); // userをemitで渡す
    if (props.selectedActionStaffSearchCallback) {
      props.selectedActionStaffSearchCallback(Staff);
    }
    closeModal();
  };
  
  // 初期化処理
  onMounted(async () => {
    //await init();
  });
  
  const paginatedList = computed(() => {
    const start: number = (currentPage.value - 1) * itemsPerPage.value;
    const end: number = start + itemsPerPage.value;
    return Staffs.value.filter(Staff => Staff.staffName?.includes(StaffName.value)).slice(start, end);
   });

   watch(
  () => props.isModalStaffSearchVisible,
  async (newValue, oldValue) => {
    if (newValue !== oldValue && newValue == true) {
      await init()
    }
  }
);
  </script>


  
  <style scoped>
    
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    right: 0; /* 画面全体に広がるように調整 */
    bottom: 0; /* 画面全体に広がるように調整 */
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center; /* 中央に配置 */
    justify-content: center; /* 中央に配置 */
    transition: opacity 0.3s ease;
  }
  
  .modal-container {
    width: 600px; /* モーダルの幅 */
  
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }
  
  .modal-header,
  .modal-footer {
    padding: 2px 0;
    border-bottom: 1px solid #dee2e6;
  }
  
  .modal-header:last-child {
    border-bottom: none;
  }
  
  .modal-body {
    margin: 5px 0;
    overflow-y: auto; /* 内容が多い場合にスクロール可能に */
    max-height: 450px; /* モーダルの最大高さ */
  }
  
  .modal-enter-active,
  .modal-leave-active {
    transition: opacity 0.5s ease;
  }
  
  .modal-enter-from,
  .modal-leave-to {
    opacity: 0;
  }
  
  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    transform: scale(1.1);
  }

  .pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px; /* 必要に応じて余白を調整 */
  width: 100%;
}
  </style>
  
